import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as $ from 'jquery';
import { IAsset } from './asset.interface';
import { AssetConfig } from './asset-config.interface';
import { MaterializeAction } from 'angular2-materialize';
import { ModalPromptComponent } from '../../shared/helper-components/modal-prompt.component';
import { ModalPromptService } from '../../shared/helper-components/modal-prompt.service';
import { ISubscription } from 'rxjs/Subscription';
import { AssetImageProcessing } from './asset-image-processing.service';
import { AssetDocumentProcessing } from './asset-document-processing.service';
import { AppUtils } from '../../shared/utils';
@Component({
    selector: 'clearance-image',
    template: require('./clearance-item-image.component.html'),
    providers: [
        AssetImageProcessing,
        AssetDocumentProcessing
    ]
})

export class ClearanceItemAssetBaseComponent implements OnDestroy, OnInit {
    ngOnInit(): void {
        this.assetItemForm.get('downloading').valueChanges.subscribe(v=>{
            if (!v){
                this.unsetClass('value change');
            }
        });
    }
    
    ngOnDestroy(): void {
        if (this.promptSubscription && !this.promptSubscription.closed)
            this.promptSubscription.unsubscribe();
    }

    @ViewChild('assetThumbnail') thumbnail: ElementRef;
    //@ViewChild(ModalPromptComponent) private modal: ModalPromptComponent;

    config: AssetConfig;

    @Input('group')
    public assetItemForm: FormGroup;
    @Input('current')
    public current: number;
    @Input('hideReportDefaultIcons')
    public hideReportDefaultIcons: boolean;
    @Input()
    public preventRemoval: boolean;  
    @Output() setDefault = new EventEmitter<FormGroup>()
    @Output() remove = new EventEmitter<number>()
    @Output() enlarge = new EventEmitter<FormGroup>()
    @Output() showOnReport = new EventEmitter<FormGroup>()
    @Output() download = new EventEmitter<FormGroup>()

    public largeImage: string;
    thumbnailIsClicked: boolean = false;
    directDownloading:boolean=false;

    constructor(private _prompt: ModalPromptService){
     
    }

    setClass(e) {
        this.thumbnailIsClicked = true;
    }

    unsetClass(msg: string = '') {
        this.thumbnailIsClicked = false;
    }

    stopPropagation(e): void {
        e.stopPropagation();
    }

    setDefaultItem(event) {
        this.setDefault.next(event);
        return false;
    }

    promptSubscription: ISubscription;

    removeItem($event) {
        this.promptSubscription = this._prompt.openModal(this.deleteAsset, this.current).first().subscribe(r=>{
            if (r){
                //this.remove.next(r);
                console.log('item #:' + r + ' was removed');
            }
        });
        return false;
    }

    showItemOnReport($event) {
        this.showOnReport.next($event);
        return false;
    }

    downloadItem(asset, e) {
        this.download.next(asset);
        e.stopPropagation();
        
        return false;
    }

    showFullSize(e) {
        this.enlarge.next(e);
        return false;
    }

    deleteAsset = (param: number) : boolean => {
        this.remove.next(param);
        return true;
    }

    openInNew(e){
        var template = AppUtils.openInNewTemplate();
        var imageWindow = window.open();
        var imageDocument = imageWindow.document.open();
        var deviceHeight =  window.innerHeight * 0.97;
        var deviceWidth =  window.innerWidth * 0.97;
        template = template
                    .replace('{{IMAGE_NAME}}',e.value.name)
                    .replace('{{IMAGE_SOURCE}}',e.value.originalImageFullUrl)
                    .replace('{{DEVICE_HEIGHT}}',deviceHeight.toString())
                    .replace('{{DEVICE_WIDTH}}',deviceWidth.toString());
        imageDocument.write(template);
        imageDocument.close();
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/asset-management/clearance-item-asset-base.component.ts